export default __webpack_public_path__ + "static/media/search.b0fe79c1.svg";